import type { Patient } from "@louise/patients/patients.types";

export type FertilityIntentStage = NonNullable<
  Patient["fertilityIntent"]
>["stage"];

/**
 * The onboarding stage (`fertilityIntent.stage`) in journey-stage vocabulary.
 *
 * The server's experience context returns the onboarding stage exactly as it
 * was saved, so the canonical projection and the Home fallback both read it
 * through this one mapping.
 *
 * `post-treatment` is deliberately left unmapped. No onboarding option saves
 * it: a patient who has finished a treatment picks a goal, usually a new
 * cycle, and records the past one through past cycles, medical history and the
 * cryo vault (#3666). Read as `complete`, an IVF cycle with no recorded result
 * would resolve to `results_missing`, "Your IVF result is still to come".
 */
export function journeyStageFromFertilityStage(
  stage: string | null | undefined,
): "trying-naturally" | "explore" | "before-treatment" | "in-care" | null {
  switch (stage) {
    case "trying-naturally":
      return "trying-naturally";
    case "exploring-options":
      return "explore";
    case "getting-ready":
      return "before-treatment";
    case "in-treatment":
      return "in-care";
    default:
      return null;
  }
}
